<template>
<div class="chapter">
<div class="inner_page">
<div id="Authors_Note">
<p class="fm-title"><b>Author’s Note</b><span epub:type="pagebreak" id="pagevi"></span></p>
<p class="noindent1"><span class="dropcap">T</span>his book contains numerous extracts from Sir John Moore’s correspondence and journals. I make no excuse for heavy use of these, for it is in his own words that the way he thought and reacted in various situations allows the character of the man to shine through. And for those who are as fortunate, as I have been, to see the original documents in Moore’s own hand, the way his writing deteriorates in times of stress is equally telling.</p>
<p class="para">I have relied on these documents rather than any of the published biographies; these range from the hagiographic versions written soon after his death, through indignant defences of his reputation published early in the twentieth century (based mainly on the previous biographies) and a mid-twentieth-century biography which includes much tangential material and much use of author’s licence and imagination which frequently takes it away from the factual to the fictional. Unfortunately most of the later writings on Moore rely heavily on this book and thus the myths have been perpetuated. Those who have previously read of Moore may wonder why I have omitted some details found elsewhere; this is because I have been unable to find a credible source for them.</p>
<p class="para">But I have not ignored the academic studies that deal in depth with specific military situations in which Moore was involved, or the military histories such as William Napier’s and Sir Charles Oman’s histories of the Peninsular War or Sir John Fortescue’s multi-volume <i>History of the British Army</i>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Authors_Note.vue?677d47cc